import {
  APP_SUPPORTS_TURNSTILE,
  IS_CAPTCHA_APP,
  IS_MOBILE_WEBVIEW,
} from "common/constants";
import { useGeetest } from "utils/hooks/useGeetest";
import {
  hasUsableTurnstileSiteKey,
  useTurnstile,
} from "utils/hooks/useTurnstile";

export const useCaptcha =
  !hasUsableTurnstileSiteKey() ||
  (IS_CAPTCHA_APP && !APP_SUPPORTS_TURNSTILE) ||
  IS_MOBILE_WEBVIEW
    ? useGeetest
    : useTurnstile;
